import React, { useEffect } from "react";

// PC/SP切替広告のReactコンポーネント
const AdIMobile = (props) => {
    useEffect(() => {
        // windowオブジェクトの広告リストを初期化
        if (!window["adsbyimobile"])
            window["adsbyimobile"] = [];
        // 広告リストを取得
        const adsbyimobile = window["adsbyimobile"];
        // 広告リストになかったら追加
        if (!adsbyimobile.some(ad => ad.elementid === props.id))
            adsbyimobile.push({
                pid: props.pid,
                mid: props.mid,
                asid: props.asid,
                display:"inline",
                elementid: props.id,
                type: "banner"
            });
        // 外部JSを読み込んで広告リストを実際に表示
        const tag = document.createElement('script');
        tag.src = 'https://imp-adedge.i-mobile.co.jp/script/v1/spot.js?20220104';
        tag.async = true;
        document.body.appendChild(tag);
        // アンマウント時にJSタグと広告情報を削除
        return () => {
            document.body.removeChild(tag);
            //admaxads.splice(admaxads.findIndex(ad =>
            //    ad.admax_id === props.id), 1);
            //window["__admax_tag__"] = undefined;
        }
    }, []);
    return <div id={props.id} />
}

export default AdIMobile